import { API_BASE_URL } from './config';
import authService from './authService';

const BASE = `${API_BASE_URL}/messages`;

const authFetch = async (url, opts = {}) => {
  const res = await fetch(url, {
    ...opts,
    headers: { ...authService.getAuthHeaders(), ...opts.headers },
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.message || `HTTP ${res.status}`);
  return data;
};

export const getInbox = () => authFetch(BASE);

export const getUnreadCount = () => authFetch(`${BASE}/unread-count`);

export const getThread = (threadId) => authFetch(`${BASE}/${threadId}`);

export const createThread = (subject, body, files = [], recipientId = null) => {
  const fd = new FormData();
  if (subject) fd.append('subject', subject);
  fd.append('body', body);
  if (recipientId) fd.append('recipientId', recipientId);
  files.forEach(f => fd.append('files', f));
  const headers = { Authorization: `Bearer ${localStorage.getItem('authToken') || ''}` };
  return fetch(BASE, { method: 'POST', headers, body: fd })
    .then(r => r.json().then(d => { if (!r.ok) throw new Error(d.message || `HTTP ${r.status}`); return d; }));
};

export const sendMessage = (threadId, body, files = []) => {
  const fd = new FormData();
  fd.append('body', body);
  files.forEach(f => fd.append('files', f));
  const headers = { Authorization: `Bearer ${localStorage.getItem('authToken') || ''}` };
  return fetch(`${BASE}/${threadId}/messages`, { method: 'POST', headers, body: fd })
    .then(r => r.json().then(d => { if (!r.ok) throw new Error(d.message || `HTTP ${r.status}`); return d; }));
};

export const getAttachmentUrl = (filename) =>
  `${API_BASE_URL.replace('/api/v1', '')}/uploads/${filename}`;
